export default "__VITE_ASSET__BnbO_lMp__"